import { ReactNode } from "react";

import { Label } from "@upstageai/ui";

import { cn } from "../../utils/style";

export function ConfigOptionLabel({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-9 items-center justify-between">
      <Label className="body-medium capitalize">{children}</Label>
    </div>
  );
}

export function ConfigOption({
  label,
  description,
  children,
  orientation = "horizontal",
}: {
  label: ReactNode;
  description?: ReactNode;
  children: ReactNode;
  orientation?: "horizontal" | "vertical";
}) {
  return (
    <div
      className={cn(
        "flex justify-between",
        orientation === "vertical" && "flex-col",
      )}
    >
      <div className={cn("flex flex-col")}>
        <ConfigOptionLabel>{label}</ConfigOptionLabel>
        {description && (
          <div className="subtle mb-4 text-surface-subtle">{description}</div>
        )}
      </div>
      <div
        className={cn(
          "flex items-center",
          orientation === "horizontal" && "justify-end",
        )}
      >
        {children}
      </div>
    </div>
  );
}
